import { lazy, Suspense } from 'react';
import { Route, Routes, Navigate } from 'react-router-dom';
import { RequireAuth } from './components/auth/RequireAuth';
import { RequireRole } from './components/auth/RequireRole';

const HomePage = lazy(() => import('./pages/HomePage'));
const PricingPage = lazy(() => import('./pages/PricingPage'));
const PrivacyPage = lazy(() => import('./pages/legal/PrivacyPage'));
const AccessibilityPage = lazy(() => import('./pages/legal/AccessibilityPage'));
const LegalPage = lazy(() => import('./pages/legal/LegalPage'));
const LoginPage = lazy(() => import('./pages/auth/LoginPage'));
const SignupPage = lazy(() => import('./pages/auth/SignupPage'));
const DirectorOnboarding = lazy(() => import('./pages/director/OnboardingPage'));
const DirectorDashboard = lazy(() => import('./pages/director/DashboardPage'));
const TeacherDashboard = lazy(() => import('./pages/teacher/DashboardPage'));
const StudentHome = lazy(() => import('./pages/student/HomePage'));
const StudentJourney = lazy(() => import('./pages/student/JourneyRouter'));
const StudentChallenge = lazy(() => import('./pages/student/ChallengeRouter'));
const StudentTutorial = lazy(() => import('./pages/student/TutorialPage'));
const StudentPresentation = lazy(() => import('./pages/student/PresentationPage'));
const NotFound = lazy(() => import('./pages/NotFoundPage'));

function PageLoader() {
  return (
    <div className="min-h-screen flex items-center justify-center text-ink-soft">
      <div className="animate-pulse">Chargement…</div>
    </div>
  );
}

export default function App() {
  return (
    <Suspense fallback={<PageLoader />}>
      <Routes>
        {/* Public */}
        <Route path="/" element={<HomePage />} />
        <Route path="/tarifs" element={<PricingPage />} />
        <Route path="/confidentialite" element={<PrivacyPage />} />
        <Route path="/accessibilite" element={<AccessibilityPage />} />
        <Route path="/mentions-legales" element={<LegalPage />} />
        <Route path="/connexion" element={<LoginPage />} />
        <Route path="/inscription" element={<SignupPage />} />

        {/* Directeur — onboarding accessible dès qu'on est loggué (avant d'avoir une école) */}
        <Route
          path="/directeur/onboarding"
          element={
            <RequireAuth>
              <DirectorOnboarding />
            </RequireAuth>
          }
        />
        <Route
          path="/directeur"
          element={
            <RequireAuth>
              <RequireRole role="director">
                <DirectorDashboard />
              </RequireRole>
            </RequireAuth>
          }
        />

        {/* Enseignant */}
        <Route
          path="/enseignant"
          element={
            <RequireAuth>
              <RequireRole role="teacher">
                <TeacherDashboard />
              </RequireRole>
            </RequireAuth>
          }
        />

        {/* Élève — auth custom (join_code + pin), pas de RequireAuth */}
        <Route path="/eleve" element={<StudentHome />} />
        <Route path="/eleve/parcours" element={<StudentJourney />} />
        <Route path="/eleve/defi/:levelId" element={<StudentChallenge />} />
        <Route path="/eleve/tutoriel/:role" element={<StudentTutorial />} />
        <Route path="/eleve/presentation" element={<StudentPresentation />} />

        <Route path="/404" element={<NotFound />} />
        <Route path="*" element={<Navigate to="/404" replace />} />
      </Routes>
    </Suspense>
  );
}
